export default{tabNavigationItem:"w_EG",isCurrent:"w_EH",label:"w_EI",leadingIcon:"w_EJ",trailing:"w_EK"};
